import { Injectable, OnDestroy } from '@angular/core';
import { AuthService } from './auth.service';
import { map, Observable, Subscription } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({
    providedIn: 'root'
})
export class UserService implements OnDestroy {
    userBasicData: any = {};
    subscriptions: Subscription[] = [];

    constructor(
        private authService: AuthService,
        private api: ApiService
    ) {}

    getUpdatedProfile() {
        return this.api.post('v1/users/updated-profile');
    }

    getUserBasicData() {
        return new Promise(fulfill => {
            let isLoggedIn = this.authService._getDefaultAuthStatus();

            if (isLoggedIn) {
                if (Object.keys(this.userBasicData)?.length) fulfill(this.userBasicData);
                else {
                    const profileSub = this.getUpdatedProfile().subscribe({
                        next: (res: any) => {
                            if (res.status == 200) {
                                this.setUserBasicData(res.data);
                                fulfill(res.data);
                            } else {
                                this.setUserBasicData({});
                                fulfill(null);
                            }
                        },
                        error: () => {
                            this.setUserBasicData({});
                            fulfill(null);
                        }
                    });
                    this.subscriptions.push(profileSub);
                }
            } else {
                this.setUserBasicData({});
                fulfill(null);
            }
        });
    }

    getTncContent(): Observable<any> {
        return this.api.get('lending-page/page-detail-by-language?slug=terms').pipe(
            map((res: { status: number; data: any }) => {
                if (res.status == 200) {
                    return res.data;
                } else {
                    return undefined;
                }
            })
        );
    }

    agreeToTnC() {
        return this.api.put('v1/users/terms-and-condition');
    }

    setUserBasicData(userObject) {
        this.userBasicData = userObject || {};
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
